import React, { memo } from "react";
import intl from "../../../../i18n/intl";
import ShopifyModal from "../../../../components/ShopifyModal";

const ArchiveOrderModal = memo(
  ({ setDlocalTip,dlocalTip,getPageData}) => {
    return (
      <div>
        <ShopifyModal
          id="order-fulfillment-dlocal-pay-tip-modal"
          open={dlocalTip}
          onClose={() => {
            setDlocalTip(false);
            getPageData();
          }}
          heading={intl.get("Payment Confirm")}
          primaryAction={{
            content: intl.get("Okay"),
            onAction: () => {
              setDlocalTip(false);
              getPageData();
            },
          }}
        >
            {`Please ensure that you have completed the payment for your order and confirmed that the Dropshipman order status has changed to "Paid" before the order can be fulfilled.`}
        </ShopifyModal>
      </div>
    );
  }
);

export default ArchiveOrderModal;
